module.exports = __webpack_public_path__ + "static/media/Mobile_Icon.01654bc7.svg";